import { LOGGED_IN } from "../const";

export const getUserIsLogin = () => {
  try {
    const isLogin = localStorage.getItem(LOGGED_IN);
    return isLogin;
  } catch (e) {
    return undefined;
  }
};
